let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hTdV3")).then(() => parcelRequire('2O328'));